
export { AffiliateBadgeType } from "/srv/parcel_monitor_community/modules/pmt/interfaces/affiliate.interface.ts"